<template>
  <div class="Demo">
    <section class="container-fluid" id="header">
      <div class="container">
        <nav class="navbar navbar-expand-lg navbar-dark">
          <a class="navbar-brand" href="#">
            <img src="../assets/img/demo.svg" width="100" height="48" alt="logo">
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarToggler"
            aria-controls="navbarTogglerDemo02"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarToggler">
            <ul class="navbar-nav justify-content-end col-11">
              <li class="nav-item">
                <a class="nav-link active" href="#">Home</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#about">About</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#features">Features</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#pricing">Pricing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#screenshots">Screenshot</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#contact">Contact</a>
              </li>
            </ul>
          </div>

          <button  class="btn btn-light my-2 my-sm-0" id="hello">
            <router-link to="/Login">Login </router-link>or
            <router-link to="/Register">Register</router-link>
          </button>
        </nav>
        <div class="row justify-content-center">
          <div class="col-8 col-lg-5 order-2 order-lg-1">
            <div class="mobilni-telefon mx-auto">
              <img src="../assets/img/mob.png" alt="mobile" class="img-fluid">
            </div>
          </div>
          <div class="col-12 col-lg-7 order-1 order-lg-2 text-center text-lg-right mx-auto">
            <h1>The Best App to Increase Your Productivity</h1>
            <p class="lead">
              A mobile app is a computer program designed to run on a
              mobile device such as a phone/tablet or watch.
            </p>
            <div class="row justify-content-center justify-content-lg-end mt-5">
              <div class="col-5">
                <a
                  href="https://www.apple.com/ios/app-store/"
                  class="btn btn-light btn-sm btn-md-lg btn-block mr-0"
                >
                  <div class="row justify-content-center align-items-center px-0 px-lg-4">
                    <img src="../assets/img/apple-logo.svg" alt class="col-3 col-lg-4 img-fluid">
                    <span class="col-8">
                      Get It From
                      <strong>Appstore</strong>
                    </span>
                  </div>
                </a>
              </div>
              <div class="col-5">
                <a
                  href="https://play.google.com/store"
                  class="btn btn-light btn-sm btn-md-lg btn-block ml-1"
                >
                  <div class="row justify-content-center align-items-center px-lg-4">
                    <img src="../assets/img/play-store.png" alt class="col-3 col-lg-4 img-fluid">
                    <span class="col-8">
                      Get It From
                      <strong>Playstore</strong>
                    </span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="container container-2" id="about">
      <div class="container row">
        <div class="col-12">
          <h2 class="text-center p-1">About The App</h2>
          <p class="lead text-center">
            Writers and stars of Veep have responded incredulously to the news an Australian
            politician required preinstalled stitches way email client, calendar, mapping program.
          </p>
        </div>
      </div>
      <div class="row justify-content-center justify-content-xl-between mt-5 mb-4">
        <div class="col-3 app-box shadow-lg p-3 mb-5 bg-white rounded">
          <div class="rectangle mx-auto mt-5">
            <img src="../assets/img/headphones.png" alt class="img-fluid normal p-2">
          </div>
          <h4 class="pt-5 pb-4 text-center">24/7 Support</h4>
          <p class="text-center">
            Apps that are not preinstalled are usually available through distribution platforms
            called app stores.
          </p>
        </div>
        <div class="col-3 app-box shadow-lg p-3 mb-5 ml-2 bg-white rounded">
          <div class="rectangle mx-auto mt-5">
            <img src="../assets/img/privacy.png" alt class="img-fluid normal p-2">
          </div>
          <h4 class="pt-5 pb-4 text-center">Data Privacy</h4>
          <p class="text-center">
            Apps that are not preinstalled are usually available through distribution platforms
            called app stores.
          </p>
        </div>
        <div class="col-3 app-box shadow-lg p-3 mb-5 ml-2 bg-white rounded">
          <div class="rectangle mx-auto mt-5 d-flex justify-content-center">
            <img src="../assets/img/download.png" alt class="img-fluid normal">
          </div>
          <h4 class="pt-5 pb-4 text-center">Easy Download</h4>
          <p class="text-center mb-5">
            Apps that are not preinstalled are usually available through distribution platforms
            called app stores.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Demo",
  mounted () {
  if (localStorage.token) {
      global.$('#hello').text(localStorage.getItem('email'))
  } 
  }
};
</script>

<style scoped>
@import "../style.css";

.container-2 {
  color: gray;
}
.rectangle {
  height: 80px;
  width: 80px;
  border-radius: 5px;
  background-color: whitesmoke;
  transform: rotate(45deg);
}

.rectangle:hover {
  background-color: #29e4b7;
  transition: 0.7s;
}

.normal {
  transform: rotate(-45deg);
}

.app-box {
  align-content: center;
  min-width: 350px;
}
</style>

